module.exports = __webpack_public_path__ + "static/media/image7.5d34e17f.JPG";